module.exports = __webpack_public_path__ + "static/media/opinion1.2b1cab13.png";